<template>
    <div>
        <div class="basic-information-wrapper">
            <div class="form-container">
                <div class="form-title margin-b20">基础信息</div>
                <div class="base-detail-box">
                    <el-form :inline="true" :model="formData" class="demo-form-inline"
                             label-width="110px">
                        <el-row style="margin-bottom: 0">
                            <el-col :span="12" style="margin-bottom: 0">
                                <el-form-item label="评价编码：" class="base-detail" style="margin-bottom: 0">
                                    {{baseDataInfo.evaluationCode}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="评价办法：">{{baseDataInfo.evaluateMethodName}}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row style="margin-bottom: 0">
                            <el-col :span="12" style="margin-bottom: 0">
                                <el-form-item label="专业：" class="base-detail" style="margin-bottom: 0">
                                    {{baseDataInfo.specialtyName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="适用范围：">{{supplierName}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="现场审查费：">
                                    <!--                                    <el-input v-model="evaluationInfo.siteReviewFee" placeholder="请输入现场审查费"-->
                                    <!--                                              style="width: 157px;height: 30px;margin-right: 10px"></el-input>-->
                                    <span>{{evaluationInfo.siteReviewFee}} 元</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <!-- 主编单位 -->
            <div class="form-container">
                <div class="form-title margin-b20">主编单位</div>
                <div class="table-title-box editor-common-box">
                    <div class="first-box">主编单位</div>
                    <div class="last-box">操作</div>
                </div>
                <div>
                    <div v-for="(item,index) in draftCompanyList" :key="index">
                        <div class="editor-common-box table-content">
                            <div class="first-box">
                                <div v-if="index === 0" style="font-size: 12px">{{item.editorCompany}}</div>
                                <el-input v-model="item.editorCompany"
                                          v-else
                                          placeholder="请输入主编单位" style="padding: 10px"></el-input>
                            </div>
                            <div class="last-box " @click="delEditor(index)">
                                <span class="del-box" :style="{ color: index === 0 ? '#999' : '#0064C8' }">删除</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-bottom">
                    <div class="table-add" @click="addEditorChief">
                        <eui-icon class="data-icon" icon="eicon-add"/>
                        新增主编单位
                    </div>
                </div>
            </div>

            <div class="form-container">
                <div class="form-title margin-b20">范围</div>
                <div class="detail-info margin-b10">本办法规定了0708产品质量评价的评价内容和办法</div>
                <div>
                    <el-input
                            type="textarea"
                            placeholder="本办法"
                            v-model="evaluationInfo.scope"
                            maxlength="100"
                            show-word-limit>
                    </el-input>
                </div>
            </div>
            <div class="form-container" v-if="supplierType === '101'">
                <div class="form-title margin-b20">规范性引用</div>
                <div class="flex margin-b10">
                    <eui-btn type="weak" width="102" @click="addStandard" class="margin-r10">新增标准号</eui-btn>
                    <UploadGetData
                            :limit="1"
                            :fileSize="2"
                            :uploadUrl="normativeReferencesImport"
                            :verify="true"
                            @getFileInfo="getTableFourInfo"
                            :isOnlyXlsx="true"
                    />
                    <eui-btn type="weak" width="88" v-debounce="normativeReferencesDown">下载模板</eui-btn>
                </div>
                <div>
                    <div class="table-title-box common-box">
                        <div class="first-box">标准号</div>
                        <div class="second-box">标准名称</div>
                        <div class="third-box">操作</div>
                    </div>
                    <div>
                        <div v-for="(item,index) in evaluationSpecificationList" :key="index">
                            <div class="common-box table-content">
                                <div class="first-box">
                                    <el-input v-model="item.standardCode" placeholder="请输入标准号"
                                              style="padding: 10px"></el-input>
                                </div>
                                <div class="second-box">
                                    <el-input v-model="item.standardName" placeholder="请输入标准名称"
                                              style="padding: 10px"></el-input>
                                </div>
                                <div class="third-box " @click="delStandard(index)">
                                    <span class="del-box"
                                          :style="{ color: evaluationSpecificationList.length === 1 ? '#999' : '#0064C8' }">删除</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="table-bottom">
                        <div class="table-add" @click="addStandard">
                            <eui-icon class="data-icon" icon="eicon-add"/>
                            新增标准号
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-container"  v-if="supplierType === '101'">
                <div class="form-title margin-b20">权重</div>
                <tip-message :tipData="tipData" v-if="showTipFlag"/>
                <el-form :inline="true" :model="evaluationInfo" ref="ruleForm"  class="demo-form-inline" :rules="rulesWeight"
                         label-width="220px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="工厂现场评审(生产保障能力)：" prop="sceneCheckWeight">
                                <el-input v-model="evaluationInfo.sceneCheckWeight" placeholder="请输入"
                                          @change="calWeight"
                                          @input="limitInput($event, 'sceneCheckWeight')"
                                          style="width: 180px;height: 30px;margin-right: 10px"></el-input>
                                <span style="color: #666">%</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="产品性能测试：" prop="entityCheckWeight">
                                <el-input v-model="evaluationInfo.entityCheckWeight" placeholder="请输入"
                                          @change="calWeight"
                                          @input="limitInput($event, 'entityCheckWeight')"
                                          style="width: 157px;height: 30px;margin-right: 10px"></el-input>
                                <span style="color: #666">%</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </div>
        <div class="flex-c">
            <eui-btn type="weak" v-debounce="() => tempSaveOrConfirmNext(0)">保 存</eui-btn>
            <eui-btn type="primary"  v-debounce="() => tempSaveOrConfirmNext(1)">下一步</eui-btn>
        </div>
    </div>
</template>

<script>
    import tipMessage from './tipMessage';
    import api from '@/modules/projectA/api/ESorganization/index';
    import UploadGetData from './uploadGetData.vue';
    import utils from '@/modules/projectA/utils/utils';

    export default {
        name: "basicInformation",
        components: {tipMessage, UploadGetData},
        props: {
            supplierType: {
                type: String,
                default: ''
            },
            evaluationId: {
                type: Number,
                default: 1687
            }
        },
        data() {
            return {
                supplierTypeList: [
                    {name: '全部', id: ''},
                    {name: '生产商', id: 101},
                    {name: '代理商', id: 102},
                    {name: '流通商', id: 103},
                ],
                draftCompanyList: [],
                normativeReferencesImport: '',
                showTipFlag: false,
                weightFormData: {},
                formData: {},
                input: '',
                tipData: ['各项权重总计不等于100%，请核对并修改'],
                rulesWeight: {
                    sceneCheckWeight: [{required: true, message: '工厂现场评审(生产保障能力)不能为空', trigger: 'change'}],
                    entityCheckWeight: [{required: true, message: '产品性能测试不能为空', trigger: 'change'}],
                },
                textarea: '',
                //基础信息
                baseDataInfo: {},
                //范围
                evaluationInfo: {},
                //规范性引用
                evaluationSpecificationList: [],
                supplierName:'',
            }
        },
        methods: {
            //基础 信息 导入
            getTableFourInfo(info) {
                let result = info;
                result.forEach((item, index) => {
                    this.$set(item, 'sortNum', Number(index) + 1);
                })
                this.evaluationSpecificationList = result;
            },
            async normativeReferencesDown() {
                const result = await api.normativeReferencesDown();
                if (result.type == 'application/json') {
                    utils.fileExportResponseError(result);
                } else {
                    utils.downFile(result, '规范性引用', '.xls');
                }
            },
            //规范性引用 校验
            testEvaluationSpecification(){
                let mesageTip = '';
                this.evaluationSpecificationList.forEach(item=>{
                    if(!item.standardCode){
                      return   mesageTip = '标准号不能为空。';
                    }
                    if(!item.standardName){
                     return    mesageTip = '标准名称不能为空。';
                    }
                })
                return mesageTip ? mesageTip : false;
            },
            //各种输入的校验
            testInput(){
                //生产商 才校验
                if(this.supplierType === '101'){
                    this.calWeight();
                    if(this.showTipFlag){
                        return false;
                    }
                    let mesageTip = this.testEvaluationSpecification();
                    //规范性引用 校验
                    if(mesageTip){
                        this.$message.warning(mesageTip);
                        return false;
                    }

                    //权重校验
                    this.$refs['ruleForm'].validate((valid) => {
                        if (!valid) {
                            return false;
                        }
                    });
                }

                //主编单位得校验
                let testDraftCompany = false;
                this.draftCompanyList.forEach(item=>{
                    if(!item.editorCompany){
                        testDraftCompany = true;
                    }
                })
                if(testDraftCompany){
                    this.$message.warning('主编单位不能为空');
                    return false;
                }

                //范围校验
                if(!this.evaluationInfo.scope){
                    this.$message.warning('范围不能为空。');
                    return false;
                }
                return true;

            },
            //0 是 保存，1 是 下一步
            async tempSaveOrConfirmNext(tempSaveOrConfirmNext) {
                    if(tempSaveOrConfirmNext === 1 && !this.testInput()){
                        return false;
                    }

                this.evaluationInfo.draftCompanyList = this.draftCompanyList.map(item => item.editorCompany);
                let params = {
                    tempSaveOrConfirmNext: tempSaveOrConfirmNext,
                    currentStep: 1,
                    evaluationCode: this.baseDataInfo.evaluationCode,
                    evaluationId: this.baseDataInfo.evaluationId,
                    evaluationInfo: this.evaluationInfo,

                }

                if(this.supplierType === '101'){
                    params.evaluationSpecificationList = this.evaluationSpecificationList
                }

                let res = await api.tempSaveOrConfirmNext(params);
                if (res.success) {
                    if (tempSaveOrConfirmNext === 1) {
                        this.$emit('getStep', 2);
                    } else {
                        this.$message.success('保存成功。')
                    }
                }
            },
            async auxiliaryStepDetail() {
                let params = {
                    currentStep: 1,
                    evaluationId: this.evaluationId,
                };
                let res = await api.auxiliaryStepDetail(params);
                if (res.success) {
                    this.baseDataInfo = res.data;
                    this.evaluationInfo = res.data.evaluationInfo;
                    this.evaluationInfo.draftCompanyList.forEach(item => {
                        this.draftCompanyList.push({editorCompany: item})
                    })

                    if(this.baseDataInfo.supplierType){
                        let supplier = this.supplierTypeList.filter(item => item.id === Number(this.baseDataInfo.supplierType));
                        this.supplierName = supplier[0].name;
                    }


                    this.evaluationSpecificationList = res.data.evaluationSpecificationList || [];

                    if (this.evaluationSpecificationList.length === 0) {
                        this.evaluationSpecificationList = [
                            {
                                sortNum: 1,
                                standardCode: '',
                                standardName: ''
                            }
                        ];
                    }
                }
            },
            //增加
            addEditorChief() {
                this.draftCompanyList.push({editorCompany: ''})
            },
            addStandard() {
                let params = {
                    standardCode: '',
                    standardName: '',
                    sortNum: this.evaluationSpecificationList.length + 1
                }
                this.evaluationSpecificationList.push(params);
            },
            delEditor(index) {
                if (index === 0) {
                    return false;
                }
                this.draftCompanyList.splice(index, 1)
            },
            delStandard(index) {
                if (this.evaluationSpecificationList.length === 1) {
                    return false;
                }
                this.evaluationSpecificationList.splice(index, 1)
            },
            limitInput(value, name) {
                this.evaluationInfo[name] = ('' + value) // 第一步：转成字符串
                    .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
                    .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
                    .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
                    .match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
            },
            calWeight() {
                if (this.evaluationInfo.entityCheckWeight !== null && this.evaluationInfo.sceneCheckWeight !== null) {
                    let num = Number(this.evaluationInfo.entityCheckWeight) + Number(this.evaluationInfo.sceneCheckWeight);
                    if (num === 100) {
                        this.showTipFlag = false;
                    } else {
                        this.showTipFlag = true;
                    }
                } else {
                    this.showTipFlag = true;
                }

            },
        },
        mounted() {
            this.auxiliaryStepDetail();
            this.normativeReferencesImport = api.normativeReferencesImport();
        }
    }
</script>

<style scoped lang="scss">
    .basic-information-wrapper {
        .detail-info {
            font-size: 14px;
            color: #333;
        }

        .base-detail-box {
            ::v-deep .el-form-item__label {
                color: #666;
            }

            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }

            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }
        }

        .common-box {
            width: 100%;
            display: flex;
            align-items: center;
            text-align: center;
            border: 1px solid #DCDCDC;
            border-bottom: none;
            font-size: 12px;
            color: #333;
            font-weight: 500;

            .first-box {
                flex: 1.2;
                height: calc(100% - 1px);
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #DCDCDC;
            }

            .second-box {
                flex: 2;
                height: calc(100% - 1px);
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #DCDCDC;
            }

            .third-box {
                flex: 0.8;
            }
        }

        /*主编单位*/
        .editor-common-box {
            width: 100%;
            display: flex;
            align-items: center;
            text-align: center;
            border: 1px solid #DCDCDC;
            border-bottom: none;

            .first-box {
                flex: 1;
                height: calc(100% - 1px);
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #DCDCDC;
            }

            .last-box {
                width: 164px;
            }
        }

        .table-title-box {
            height: 40px;
            background-color: #F5F5F5;
            font-size: 12px;
            color: #333;
            font-weight: bold;
        }

        .table-content {
            height: 50px;

            .del-box {
                color: #0064C8;
                cursor: pointer;
                font-size: 12px;
            }
        }

        .table-bottom {
            height: 60px;
            padding: 10px;
            background-color: #F5F5F5;
            border: 1px solid #DCDCDC;

            .data-icon {
                width: 10px;
                height: 10px;
                margin-right: 10px;
            }

            .table-add {
                cursor: pointer;
                background-color: #fff;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
            }
        }
    }

</style>